import createReactComponent from '../createReactComponent';
export default createReactComponent('mobiledata-off', 'IconMobiledataOff', [
  ['path', { d: 'M16 12v-8', key: 'svg-0' }],
  ['path', { d: 'M8 20v-8', key: 'svg-1' }],
  ['path', { d: 'M13 7l3 -3l3 3', key: 'svg-2' }],
  ['path', { d: 'M5 17l3 3l3 -3', key: 'svg-3' }],
  ['path', { d: 'M3 3l18 18', key: 'svg-4' }],
]);
